import { Typography, Card, CardContent, Grid, Avatar, Button } from '@mui/material'
import React from 'react'
import * as yup from 'yup'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { useFormik } from 'formik'
import TextField from '@mui/material/TextField'
import { loginAdmin } from '../../actions/auth'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'

const validationSchema = yup.object({
  email: yup.string('Vui lòng điền email').email('Email không đúng định dạng').required('Vui lòng điền email'),
  password: yup.string('Vui vòng điền mật khẩu').required('Vui lòng điền mật khẩu')
})

const Login = () => {
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)

  const handleSubmit = async () => {
    console.log('formik.values.email:', formik.values.email)

    console.log('formik.values.password:', formik.values.password)

    dispatch(loginAdmin(formik.values.email, formik.values.password))
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: validationSchema,
    onSubmit: handleSubmit
  }
  )

  if (auth.isAuthenticated) {
    return <Redirect to='/admin/dashboard' />
  }

  return (
    <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card style={{ maxWidth: '50%' }}>
        <CardContent>
          <Grid container direction='column' justifyContent='center' alignItems='center' spacing={2}>
            <Grid item>
              <Avatar>
                <LockOpenIcon />
              </Avatar>
            </Grid>

            <Grid item>
              <Typography variant='h4'>Đăng nhập tài khoản Admin</Typography>
            </Grid>

            <Grid item>
              <form onSubmit={formik.handleSubmit}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  style={{ marginBottom: '1em' }}
                />

                <TextField
                  fullWidth
                  id="password"
                  name="password"
                  label="Password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  helperText={formik.touched.password && formik.errors.password}
                  style={{ marginBottom: '1em' }}
                />

                <Button color="primary" variant="contained" fullWidth type="submit" style={{ color: 'white' }}>
                  Đăng nhập
                </Button>
              </form>
            </Grid>
          </Grid>
        </CardContent>
      </Card >
    </div >
  );
}

export default Login
